exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".mainSearch__searchBar___1r_h-{width:90%;display:inline-block;max-width:700px}.mainSearch__searchBar___1r_h- input{width:99%}.mainSearch__searchBar___1r_h- button{right:0;left:auto}.mainSearch__searchBar___1r_h- a{text-decoration:none}@media(max-width:960px){.mainSearch__searchBar___1r_h-{width:100%}}", ""]);

// exports
exports.locals = {
	"searchBar": "mainSearch__searchBar___1r_h-"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/postcss-loader!./src/client/components/PagePerformance/overrides/mainSearch.pcss
// module id = 926
// module chunks = 0